import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useFormik } from 'formik'; // Adjust the import path as necessary
import { useSelector, useDispatch } from 'react-redux';
import { Box, Grid, Paper, Typography, Stack, Button, Backdrop, CircularProgress, Autocomplete, TextField } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { validationSchema } from './validationSchema';
import CustomTextField from './customTextField';
import CustomRadioButton from './customRadioGroup';
import CustomAutoComplete from './customAutoComplete';
import {
  vehicleType,
  mode,
  transTypes,
  initialValues,
  outwardSubTypes,
  inwardSubTypes,
  documentTypeOptions,
  editPartBReasons,
} from './data';
import { API, graphqlOperation } from 'aws-amplify';
import EWayBillPreview from '../../../components/modals/eWayBillPreview';
import { getCodeTranslation, getInvoiceMasterEwayBillCustom, getPurchaseMasteEwayBillrCustom, listtransporters } from '../../../graphql';
import { useLocation } from 'react-router-dom';
import { axiosInstanceForLambda } from '../../../library/Axios';
import { showSuccessSnackbar, showWarningSnackbar } from '../../../components/snackBar/snakbar';
import FormikDatePicker from '../../../components/formElements/formikDatePicker';
import Transporter from '../../../components/modals/transporter';
import API_ENDPOINTS from '../../../apiEndpoints';
import dayjs from 'dayjs';
import { useGetCodeTranslationQuery } from '../../../redux/apis/getCodeTranslation.api';
import { useCreatePdfMutation } from '../../../redux/apis/createPdf.api';
import { einvAuth, einvAuthData, einvId, einvPreview } from '../../../redux/reducers/eInvReducer';
import { humanizeKey } from '../../../utils/customerData';
const EWayBill = ({ modal = false, id }) => {
  const navigate = useNavigate();

  const subTypeRef = useRef();
  const docTypeRef = useRef();
  const transType = useRef();
  const [createPdf, progress] = useCreatePdfMutation();
  const [district1, setDistrict1] = useState([]);
  const [districtFrom, setDistrictFrom] = useState([]);
  const [districtTo, setDistrictTo] = useState([]);
  const [district2, setDistrict2] = useState([]);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [transporterOpen, setTransporterOpen] = useState(false);
  const [backdropOpen, setBackdropOpen] = useState(false);
  const [transporter, setTransporter] = useState([]);
  const [invoiceData, setInvoiceData] = useState({});
  const [lineData, setLineData] = useState();
  const [editPartB, setEditPartB] = useState(false);
  const [editTransporter, setEditTransporter] = useState(false);
  const [distErr, setDistErr] = useState(false);
  const [editPartBDetails, setEditPartBDetails] = useState({
    state: '',
    city: '',
    reasonCode: '',
    reasonDescription: '',
  });
  const dispatch = useDispatch();
  const location = useLocation();
  let prevData = useSelector((state) => state.eInvReducer.data);
  const invoice = location.state?.invoice || {};
  const pathFrom = location.state?.from;
  const saveNew = location.state?.saveNew;
  const ewayData = location.state?.data || '';
  console.log(location.state, 'location.state?');

  const { data: stateList } = useGetCodeTranslationQuery({ codetype: 'IndiaState' });

  let getCompany = useSelector((state) => state?.companyReducer?.companyDetails);
  const distBool = distErr;
  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: validationSchema(distBool),
    onSubmit: (val, act) => {
      console.log(act, 'act');
    },
  });
  const getAddressDisplay = (invoiceData) => {
    const billingAddress = invoiceData?.relatedinvoiceaddressdetails?.find((item) => item.objecttype === 'SalesBilling');

    const deliveryAddress = invoiceData?.relatedinvoiceaddressdetails?.find((item) => item.objecttype === 'SalesDelivery');

    const purchaseBillingAddress = invoiceData?.relatedpurchaseaddressdetails?.find((item) => item.objecttype === 'PurchaseBilling');

    const purchaseShippingAddress = invoiceData?.relatedpurchaseaddressdetails?.find((item) => item.objecttype === 'PurchaseDelivery');

    const line1 = billingAddress?.line1 || purchaseBillingAddress?.line1;
    const line2 = deliveryAddress?.line1 || purchaseShippingAddress?.line1;
    const city1 = billingAddress?.city || purchaseBillingAddress?.city;
    const city2 = billingAddress?.city || purchaseBillingAddress?.city;
    const district = billingAddress?.district || purchaseBillingAddress?.district;

    const district2 = deliveryAddress?.district || purchaseShippingAddress?.district;

    const pincode = billingAddress?.pincode || purchaseBillingAddress?.pincode;
    const pincode2 = deliveryAddress?.pincode || purchaseShippingAddress?.pincode;
    const stateCode = billingAddress?.statecode || purchaseBillingAddress?.statecode;

    const stateCode2 = deliveryAddress?.statecode || purchaseShippingAddress?.statecode;

    return {
      fromLine: line1,
      fromDistrict: district,
      fromPincode: pincode,
      fromStateCode: stateCode,
      fromCity: city1,
      toCity: city2,
      toLine: line2,
      toDistrict: district2,
      toPincode: pincode2,
      toStateCode: stateCode2,
    };
  };

  useEffect(() => {
    listTransporters();
    if (Object.keys(invoice).length > 0) {
      if (invoice.supply === 'O') {
        getInvoiceMasterData(invoice.id);
      } else {
        getPurchaseMasterData(invoice.id);
      }
    }
  }, []);
  const eWayDataAddress = (addresses) => {
    const billFrom = addresses.find((a) => a.objecttype === 'Eway_Billfrom');
    const billTo = addresses.find((a) => a.objecttype === 'Eway_Billto');
    const dispatchFrom = addresses.find((a) => a.objecttype === 'Eway_Dispatchfrom');
    const dispatchTo = addresses.find((a) => a.objecttype === 'Eway_Dispatchto');
    formik.setFieldValue('bfpincode', billFrom?.pincode);
    formik.setFieldValue('bfstates', billFrom?.statename + 'District');
    formik.setFieldValue('bfdistrict', billFrom?.district);
    formik.setFieldValue('bfAddress', billFrom?.line1);
    formik.setFieldValue('bfcity', billFrom?.city ?? '');
    formik.setFieldValue('dfPincode', dispatchFrom?.pincode);
    formik.setFieldValue('dfstates', dispatchFrom?.statename + 'District');
    formik.setFieldValue('dfDistrict', dispatchFrom?.district);
    formik.setFieldValue('dfAddress', dispatchFrom?.line1);
    formik.setFieldValue('dfcity', dispatchFrom?.city ?? '');
    formik.setFieldValue('dtPincode', dispatchTo?.pincode);
    formik.setFieldValue('dtstates', dispatchTo?.statename + 'District');
    formik.setFieldValue('dtdistrict', dispatchTo?.district);
    formik.setFieldValue('dtAddress', dispatchTo?.line1);
    formik.setFieldValue('dtcity', dispatchTo?.city ?? '');
    formik.setFieldValue('btpincode', billTo?.pincode);
    formik.setFieldValue('btstates', billTo?.statename + 'District');
    formik.setFieldValue('btdistrict', billTo?.district);
    formik.setFieldValue('btAddress', billTo?.line1);
    formik.setFieldValue('btcity', billTo?.city ?? '');
  };
  const setVals = () => {
    if (Object.keys(ewayData).length > 0) {
      eWayDataAddress(ewayData.addresses);
      formik.setFieldValue('supply', ewayData.supplytype);
      formik.setFieldValue('subType', ewayData.subtype);
      formik.setFieldValue('transType', String(ewayData.transactiontype));
      formik.setFieldValue('docType', ewayData.doctype);
      formik.setFieldValue('docno', ewayData.invoiceno);
      formik.setFieldValue(
        'docdate',

        dayjs.unix(ewayData?.invoicedate).format('DD/MM/YYYY')
      );
      formik.setFieldValue('tname', ewayData.transportername);
      formik.setFieldValue('modes', ewayData.modeoftransport);
      formik.setFieldValue('tdoc', ewayData.transdocno);
      formik.setFieldValue('tDate', ewayData.transdocdate);
      formik.setFieldValue('vno', ewayData.vehicleno);
      formik.setFieldValue('vtypes', ewayData.vehicletype);
      formik.setFieldValue('distance', ewayData.distance);
      formik.setFieldValue('tname', ewayData.transportergstin);
      formik.setFieldValue('tid', ewayData.transportergstin);
      formik.setFieldValue('tObj', {
        value: ewayData.transportergstin,
        label: ewayData.transportername,
      });
    }
  };
  useEffect(() => {
    if (ewayData.invoiceid) {
      const gg = async () => {
        if (ewayData.supplytype === 'O') {
          await getInvoiceMasterData(ewayData.invoiceid);
          setVals();
        } else {
          await getPurchaseMasterData(ewayData.invoiceid);
          setVals();
        }
      };
      gg();
    }
  }, [ewayData.invoiceid]);

  // useEffect(() => {
  //   if (id) {
  //     getInvoiceMasterData(id);
  //   }
  // }, [id]);

  useEffect(() => {
    if (Object.keys(formik.touched).length === 0) {
      if (
        formik.values.bfpincode !== formik.values.dfPincode ||
        formik.values.bfdistrict !== formik.values.dfDistrict ||
        formik.values.bfstates !== formik.values.dfstates
      ) {
        formik.setFieldValue('transType', '3');
      } else if (
        formik.values.btpincode !== formik.values.dtPincode ||
        formik.values.btdistrict !== formik.values.dtdistrict ||
        formik.values.btstates !== formik.values.dtstates
      ) {
        formik.setFieldValue('transType', '2');
      } else {
        formik.setFieldValue('transType', '1');
      }
    }
    // }
  }, [formik.values]);
  useEffect(() => {
    const godownAdd = getCompany.relatedaddressentity.filter((add) => add.objecttype === 'GODOWN')?.[0] || getCompany;

    if (invoiceData && Object.keys(invoiceData).length > 0) {
      const fromPartyAddress = getAddressDisplay(invoiceData);

      const fromState = states.filter((fs) => fs.stateCode == fromPartyAddress.fromStateCode)[0];
      const toState = states.filter((fs) => fs.stateCode == fromPartyAddress.toStateCode)[0];
      const bfromState = states.filter((fs) => fs.stateCode == getCompany.statecode)[0];
      const dfromState = states.filter((fs) => fs.stateCode == godownAdd.statecode)[0];
      const supplydd = invoice.supply ? invoice.supply : 'O';
      if (fromPartyAddress) {
        formik.setFieldValue('dfstatecode', fromPartyAddress.fromStateCode);
        formik.setFieldValue('dtstatecode', fromPartyAddress.toStateCode);
        if (supplydd === 'O') {
          formik.setFieldValue('bfpincode', getCompany.pincode);
          formik.setFieldValue('bfstates', bfromState?.value);
          formik.setFieldValue('bfdistrict', getCompany?.district?.endsWith('District') ? getCompany?.district : getCompany?.district);
          formik.setFieldValue('bfAddress', getCompany.line1);
          formik.setFieldValue('bfcity', getCompany.city);
          formik.setFieldValue('dfPincode', godownAdd.pincode);
          formik.setFieldValue('dfstates', dfromState?.value);
          formik.setFieldValue('dfDistrict', godownAdd?.district?.endsWith('District') ? godownAdd?.district : godownAdd?.district);
          formik.setFieldValue('dfAddress', godownAdd.line1);
          formik.setFieldValue('dfcity', godownAdd.city);
          formik.setFieldValue('dtPincode', fromPartyAddress.toPincode);
          formik.setFieldValue('dtstates', toState?.value);
          formik.setFieldValue(
            'dtdistrict',
            fromPartyAddress?.toDistrict?.endsWith('District') ? fromPartyAddress?.toDistrict : fromPartyAddress?.toDistrict
          );
          formik.setFieldValue('dtAddress', fromPartyAddress.toLine);
          formik.setFieldValue('dtcity', fromPartyAddress.toCity);
          formik.setFieldValue('btpincode', fromPartyAddress.fromPincode);
          formik.setFieldValue('btstates', fromState?.value);
          formik.setFieldValue(
            'btdistrict',
            fromPartyAddress?.fromDistrict?.endsWith('District') ? fromPartyAddress?.fromDistrict : fromPartyAddress?.fromDistrict
          );
          formik.setFieldValue('btAddress', fromPartyAddress.fromLine);
          formik.setFieldValue('btcity', fromPartyAddress.fromCity);
        } else {
          formik.setFieldValue('bfpincode', fromPartyAddress.fromPincode);
          formik.setFieldValue('bfstates', fromState?.value);
          formik.setFieldValue(
            'bfdistrict',
            fromPartyAddress?.fromDistrict.endsWith('District') ? fromPartyAddress?.fromDistrict : fromPartyAddress?.fromDistrict
          );
          formik.setFieldValue('bfAddress', fromPartyAddress.fromLine);
          formik.setFieldValue('bfcity', fromPartyAddress.fromCity);
          formik.setFieldValue('dfPincode', fromPartyAddress.toPincode);
          formik.setFieldValue('dfstates', toState?.value);
          formik.setFieldValue(
            'dfDistrict',
            fromPartyAddress?.toDistrict.endsWith('District') ? fromPartyAddress?.toDistrict : fromPartyAddress?.toDistrict
          );
          formik.setFieldValue('dfAddress', fromPartyAddress.toLine);
          formik.setFieldValue('dfcity', fromPartyAddress.toCity);
          formik.setFieldValue('dtPincode', godownAdd.pincode);
          formik.setFieldValue('dtstates', dfromState?.value);
          formik.setFieldValue('dtdistrict', godownAdd?.district.endsWith('District') ? godownAdd?.district : godownAdd?.district);
          formik.setFieldValue('dtAddress', godownAdd.line1);
          formik.setFieldValue('dtcity', godownAdd.city);
          formik.setFieldValue('btpincode', getCompany.pincode);
          formik.setFieldValue('btstates', bfromState?.value);
          formik.setFieldValue('btdistrict', getCompany?.district.endsWith('District') ? getCompany?.district : getCompany?.district);
          formik.setFieldValue('btAddress', getCompany.line1);
          formik.setFieldValue('btcity', getCompany.city);
        }
      }
    }
    if (id) {
      formik.setFieldValue('docno', invoiceData?.invoicenumber);
      formik.setFieldValue(
        'docdate',

        dayjs.unix(invoiceData?.invoicedate).format('DD/MM/YYYY')
      );
    }
  }, [invoiceData]);
  async function getInvoiceMasterData(data) {
    try {
      setBackdropOpen(true);
      const res = await API.graphql(graphqlOperation(getInvoiceMasterEwayBillCustom, { invoiceid: data }));

      if (res.data.getInvoiceMaster !== null) {
        setInvoiceData(res.data.getInvoiceMaster[0]);
        setBackdropOpen(false);
        const invAndNonInv = [...res.data.getInvoiceMaster[0]?.relatedinvoicelineitems];
        setLineData(invAndNonInv);
        formik.setFieldValue('supply', invoice.supply);
        formik.setFieldValue('docdate', invoice.docDate);
        formik.setFieldValue('docno', invoice.invoiceNo);
      }
    } catch (error) {
      console.log('error', error);
    }
    setBackdropOpen(false);
  }

  async function getPurchaseMasterData(data) {
    try {
      setBackdropOpen(true);
      const res = await API.graphql(graphqlOperation(getPurchaseMasteEwayBillrCustom, { purchaseid: data }));
      console.log(res, ':res');
      if (res.data.getPurchaseMaster !== null) {
        setInvoiceData(res.data.getPurchaseMaster[0]);
        setBackdropOpen(false);
        const invAndNonInv = [...res.data.getPurchaseMaster[0]?.relatedpurchaselineitems];
        setLineData(invAndNonInv);
      }
      formik.setFieldValue('supply', invoice.supply);
      formik.setFieldValue('docdate', invoice.docDate);
      formik.setFieldValue('docno', invoice.invoiceNo);
    } catch (error) {
      console.log('error', error);
    }
    setBackdropOpen(false);
  }
  const listTransporters = async () => {
    try {
      const transporters = await API.graphql(graphqlOperation(listtransporters));
      const list = transporters.data.listtransporters;
      const transporterList = list.map((dat) => {
        return {
          label: dat.transportername,
          value: dat.transportergstin,
          id: dat.transporterid,
        };
      });
      setTransporter(transporterList);
    } catch (err) {
      console.log(err, 'err');
    }
  };

  const handlePartB = async () => {
    const emptyFields = Object.keys(editPartBDetails).filter((key) => editPartBDetails[key] === '');
    const capitalizedArray = emptyFields.map((item) => item.charAt(0).toUpperCase() + item.slice(1));
    const labels = capitalizedArray.map(humanizeKey);
    if (editPartB === false && (ewayData.transportername === null || ewayData.transporterName === '')) {
      setEditPartB(true);
    } else if (editTransporter === false && (ewayData.transportername !== null || ewayData.transporterName !== '')) {
      setEditTransporter(true);
    } else if (editPartB === true && (ewayData.transportername === null || ewayData.transporterName === '')) {
      if (emptyFields?.length === 0) {
        const payload = {
          action: 'VEHEWB',
          data: {
            ewbNo: ewayData.ewaybillno,
            vehicleNo: formik.values.vno,
            fromPlace: editPartBDetails.city,
            fromState: editPartBDetails.state.stateCode,
            reasonCode: editPartBDetails.reasonCode.value,
            reasonRem: editPartBDetails.reasonDescription,
            transDocNo: formik.values.tdoc,
            transDocDate:
              dayjs(formik.values.tDate).format('DD/MM/YYYY') === 'Invalid Date' ? '' : dayjs(formik.values.tDate).format('DD/MM/YYYY'),
            transMode: formik.values.modes,
            vehicleType: formik.values.vtypes,
          },
          ...(Object.keys(prevData).length > 0 ? { credentials: prevData } : null),
        };
        try {
          const res = await axiosInstanceForLambda.post(API_ENDPOINTS.REACT_APP_EWAYBILL_URL, payload);
          console.log(res, 'res');
          if (res.status === 200) {
            showSuccessSnackbar('Eway bill successfully updated');
            navigate(-1);
            localStorage.setItem('ewayCheck', true);
          }
        } catch (error) {
          const filteredArray = error.response.data?.details.filter((item) => item !== null);
          const formatted =
            filteredArray?.length === 1
              ? error.response.data?.details[0]?.errorDesc + '.'
              : filteredArray?.length > 1
              ? filteredArray
                  .map((item, index) => {
                    if (index === filteredArray.length - 1) return item.errorDesc + '.';
                    return item.errorDesc + ',';
                  })
                  .join(' ')
              : error.response.data.message
              ? error.response.data.message
              : '';

          const errorMessage = formatted ? formatted : error.response.statusText;

          showWarningSnackbar(errorMessage);
        } finally {
          setBackdropOpen(false);
          dispatch(einvAuthData({}));
          dispatch(einvAuth(false));
          dispatch(einvPreview({ preview: false, id: 0 }));
          dispatch(einvId(false));
        }
      } else {
        showWarningSnackbar('Please fill ' + labels.map((g) => ' ' + g));
      }
    } else if (editTransporter === true && (ewayData.transportername !== null || ewayData.transporterName !== '')) {
      const payload = {
        action: 'UPDATETRANSPORTER',
        data: {
          ewbNo: ewayData.ewaybillno,
          transporterId: formik.values.tid,
        },
        additionalData: {
          transporterId: formik.values.tObj.id,
        },
        ...(Object.keys(prevData).length > 0 ? { credentials: prevData } : null),
      };
      setBackdropOpen(true);
      try {
        const res = await axiosInstanceForLambda.post(API_ENDPOINTS.REACT_APP_EWAYBILL_URL, payload);
        console.log(res, 'res');
        if (res.status === 200) {
          showSuccessSnackbar('Transporter successfully updated');
          setEditTransporter(false);
        }
      } catch (error) {
        console.log(error, 'error');
        const filteredArray = error.response.data?.details.filter((item) => item !== null);
        const formatted =
          filteredArray?.length === 1
            ? error.response.data?.details[0]?.errorDesc + '.'
            : filteredArray?.length > 1
            ? filteredArray
                .map((item, index) => {
                  if (index === filteredArray.length - 1) return item.errorDesc + '.';
                  return item.errorDesc + ',';
                })
                .join(' ')
            : error.response.data.message
            ? error.response.data.message
            : '';

        const errorMessage = formatted ? formatted : error.response.statusText;

        showWarningSnackbar(errorMessage);
      } finally {
        setBackdropOpen(false);
        dispatch(einvAuthData({}));
        dispatch(einvAuth(false));
        dispatch(einvPreview({ preview: false, id: 0 }));
        dispatch(einvId(false));
      }
    }
  };

  // useEffect(() => {
  //   if (formik.values.dfstates) {
  //     getDistricts(formik.values.dfstates, setDistrict1);
  //   }
  // }, [formik.values.dfstates]);
  // useEffect(() => {
  //   if (formik.values.bfstates) {
  //     getDistricts(formik.values.bfstates, setDistrictFrom);
  //   }
  // }, [formik.values.bfstates]);
  // useEffect(() => {
  //   if (formik.values.btstates) {
  //     getDistricts(formik.values.btstates, setDistrictTo);
  //   }
  // }, [formik.values.btstates]);
  // useEffect(() => {
  //   if (formik.values.dtstates) {
  //     getDistricts(formik.values.dtstates, setDistrict2);
  //   }
  // }, [formik.values.dtstates]);

  useEffect(() => {
    if (formik.values.vtypes === 'O') {
      formik.setFieldValue('modes', '1');
    }
  }, [formik.values.vtypes]);

  let states = useMemo(() => {
    if (!stateList) return [];
    return stateList.map((element) => {
      return {
        label: element.codetext,
        value: `${element.codetext}District`,
        stateCode: element.statecode,
      };
    });
  }, [stateList]);
  // async function getDistricts(variab, setfn) {
  //   try {
  //     const cities = await API.graphql(graphqlOperation(getCodeTranslation, { codetype: variab }));
  //     let disArray = (cities?.data?.getCodeTranslation).map((element) => {
  //       return {
  //         label: element.codetext,
  //         value: `${element.codetext}District`,
  //       };
  //     });
  //     setfn(disArray);
  //   } catch (error) {
  //     console.log('error in getDistricts ::: ', error);
  //   }
  // }
  const invDat =
    lineData && lineData.length > 0 && invoice.supply === 'O'
      ? lineData.map((itm, i) => {
          const gst = invoiceData.companystate === formik.values.dtstatecode ? 'c' : 'i';
          const gstAmt = Number(itm.gstamount.toFixed(2));
          const taxabilityCheck =
            invoiceData.invoicetaxabletypecd == 1 ||
            invoiceData.invoicetaxabletypecd == 6 ||
            invoiceData.invoicetaxabletypecd == 4 ||
            invoiceData.invoicetaxabletypecd == 8;
          return {
            productName: itm.itemname,
            productDesc: itm.itemname,
            hsnCode: Number(itm.hsnsaccode),
            quantity: itm.quantity ? itm.quantity : 0,
            qtyUnit: itm.unit ? itm.unit : 'OTH',
            cgstRate: gst === 'c' && taxabilityCheck ? itm.gstrate / 2 : 0,
            sgstRate: gst === 'c' && taxabilityCheck ? itm.gstrate / 2 : 0,
            igstRate: gst === 'i' && taxabilityCheck ? itm.gstrate : 0,
            cessNonAdvolValue: itm.cessamount,
            taxableAmount: Number(
              (
                Number(itm?.itemamount?.toFixed(2)) -
                Number(itm?.itemdiscount?.toFixed(2)) +
                (invoiceData?.reversechargeflag === 1 ? Number(0) : Number(gstAmt?.toFixed(2))) +
                (invoiceData?.reversechargeflag === 1 ? Number(0) : Number(itm?.cessamount?.toFixed(2)))
              ).toFixed(2)
            ),
          };
        })
      : lineData &&
        lineData.length > 0 &&
        invoice.supply === 'I' &&
        lineData.map((itm, i) => {
          const gst = invoiceData.companystate === invoiceData.placeofsupply ? 'c' : 'i';
          const gstAmt = Number(itm.gstamount.toFixed(2));
          const taxabilityCheck =
            invoiceData.invoicetaxabletypecd == 1 ||
            invoiceData.invoicetaxabletypecd == 6 ||
            invoiceData.invoicetaxabletypecd == 4 ||
            invoiceData.invoicetaxabletypecd == 8;
          return {
            productName: itm.itemname,
            productDesc: itm.itemname,
            hsnCode: Number(itm.hsncode),
            quantity: itm.itemquantity ? itm.itemquantity : 0,
            qtyUnit: itm.uqc ? itm.uqc : 'OTH',
            cgstRate: gst === 'c' && taxabilityCheck ? itm.gstrate / 2 : 0,
            sgstRate: gst === 'c' && taxabilityCheck ? itm.gstrate / 2 : 0,
            igstRate: gst === 'i' && taxabilityCheck ? itm.gstrate : 0,
            cessNonAdvolValue: itm.cessamount,
            taxableAmount: Number(
              (
                Number(itm?.itemamount.toFixed(2)) -
                Number(itm?.itemdiscount.toFixed(2)) +
                (invoiceData.reversechargeflag === 1 ? Number(0) : Number(gstAmt.toFixed(2))) +
                (invoiceData.reversechargeflag === 1 ? Number(0) : Number(itm.cessamount.toFixed(2)))
              ).toFixed(2)
            ),
          };
        });
  const userPreferece = useSelector((state) => state.userPrefrenceandReducer);
  let path = `${userPreferece?.financialYear?.companyid}/${userPreferece?.financialYear?.companybranchid}/${userPreferece?.financialYear?.financialyearid}/`;
  let url = path + 'Invoices/EwayBill/Ledgerx_Eway_Bill_${ewbNo}.pdf';
  let uri = `${API_ENDPOINTS.REACT_APP_S3_BUCKET_URL}/${url}`;

  const bfromState =
    formik.values.supply === 'I' && invoiceData.partygstcategory === 'SEZ'
      ? 99
      : states.filter((fs) => fs.value == formik.values?.bfstates)[0]?.stateCode;
  const dfromState = states.filter((fs) => fs.value == formik.values.dfstates)[0]?.stateCode;
  const btoState =
    formik.values.supply === 'O' && invoiceData.partygstcategory === 'SEZ'
      ? 99
      : states.filter((fs) => fs.value == formik.values.btstates)[0]?.stateCode;
  const dtoState = states.filter((fs) => fs.value == formik.values.dtstates)[0]?.stateCode;
  console.log(invoice, 'invoicekkk');

  const saveChanges = async (e) => {
    e?.preventDefault();
    const errors = await formik.validateForm(formik.values);
    console.log(errors, 'err');
    const labels = Object.keys(errors).map(humanizeKey);

    if (errors?.subType && subTypeRef.current) {
      subTypeRef.current.focus();
    } else if (errors?.docType && docTypeRef.current) {
      docTypeRef.current.focus();
    } else if (errors?.transType && transType.current) {
      transType.current.focus();
    }
    if (Object.keys(errors).length !== 0) {
      showWarningSnackbar('Please fill ' + labels.map((g) => ' ' + g));
    } else {
      // const gst = invoiceData.companystate === invoiceData.placeofsupply ? 'c' : 'i';
      const gst = invoiceData.companystate === formik.values.dtstatecode ? 'c' : 'i';
      let gstAmt = 0;
      let totalVal = 0;
      let cessVal = 0;
      let totItemAmt = 0;
      lineData.map((dat) => {
        gstAmt += dat.gstamount;
        totalVal += dat.itemamount;
        cessVal += dat.cessamount;
        const assVal = dat.itemamount - dat.itemdiscount + 0;
        totItemAmt += assVal;
      });
      const taxabilityCheck =
        invoiceData.invoicetaxabletypecd == 1 ||
        invoiceData.invoicetaxabletypecd == 6 ||
        invoiceData.invoicetaxabletypecd == 4 ||
        invoiceData.invoicetaxabletypecd == 8;
      const self = getCompany.relatedcompanyentity[0].gstin;
      const other = invoiceData.consigneegstin || invoiceData.partygstin;
      let payload = {
        action: 'GENEWAYBILL',
        data: {
          supplyType: modal === true ? 'O' : formik.values.supply,
          subSupplyType: formik.values.subType,
          subSupplyDesc: formik.values.subTypeDesc,
          docType: formik.values.docType || 'INV',
          docNo: formik.values.docno || invoiceData?.invoicenumber,
          docDate:
            formik.values.supply === 'O'
              ? dayjs.unix(invoiceData?.invoicedate).format('DD/MM/YYYY')
              : dayjs.unix(invoiceData?.entrydate).format('DD/MM/YYYY'),
          fromGstin:
            formik.values.supply === 'I' && formik.values.docType === 'BOE' && formik.values.subType == '2'
              ? 'URP'
              : formik.values.supply === 'I' &&
                (formik.values.subType === '5' || formik.values.subType === '12' || formik.values.subType === '8')
              ? self
              : formik.values.supply === 'O'
              ? self
              : formik.values.supply === 'I' && formik.values.subType == '9' && formik.values.docType === 'BOE'
              ? 'URP'
              : formik.values.supply === 'I' && formik.values.subType == '9' && formik.values.docType === 'BOE'
              ? 'URP'
              : formik.values.supply === 'I' && other
              ? other
              : 'URP',
          fromTrdName: formik.values.supply === 'O' ? getCompany.relatedcompanyentity[0].legalname : invoiceData.partylegalname,
          fromAddr1: formik.values.bfAddress,
          fromPlace: formik.values.dfcity,
          fromPincode: Number(formik.values.bfpincode),
          actFromStateCode: dfromState,
          fromStateCode: bfromState,
          toGstin:
            modal === true
              ? invoiceData?.consigneegstin
              : formik.values.supply === 'O' && formik.values.subType === '3'
              ? 'URP'
              : formik.values.supply === 'O' &&
                (formik.values.subType === '5' ||
                  formik.values.subType === '10' ||
                  formik.values.subType === '11' ||
                  formik.values.subType === '8' ||
                  formik.values.subType === '12')
              ? self
              : formik.values.supply === 'I'
              ? self
              : formik.values.supply === 'O' && other
              ? other
              : 'URP',
          toTrdName: formik.values.supply === 'O' ? invoiceData.partylegalname : getCompany.relatedcompanyentity[0].legalname,
          toAddr1: formik.values.supply === 'O' ? formik.values.btAddress : getCompany.line1,
          // toAddr2: "Dasarahosahalli",
          toPlace:
            // "Chennai",
            formik.values.dtcity,
          toPincode:
            // 600024,
            Number(formik.values.btpincode),
          actToStateCode:
            // 33,
            dtoState,
          transactionType: Number(formik.values.transType),
          toStateCode:
            //  33,
            btoState,
          totalValue: totItemAmt,
          cgstValue: gst === 'c' && taxabilityCheck ? gstAmt / 2 : 0,
          sgstValue: gst === 'c' && taxabilityCheck ? gstAmt / 2 : 0,
          igstValue: gst === 'i' && taxabilityCheck ? gstAmt : 0,
          cessValue: cessVal,
          totInvValue: totItemAmt + gstAmt + cessVal,

          transporterId: formik.values.tObj.value ? formik.values.tObj.value : '',
          transporterName: formik.values.tObj.label ? formik.values.tObj.label : '',
          transDocNo: formik.values.tdoc,
          // transMode: "",
          transMode: formik.values.modes,
          transDistance: formik.values.distance,
          transDocDate: formik.values.tDate ? dayjs(formik.values.tDate).format('DD/MM/YYYY') : '',
          vehicleNo: formik.values.vno,
          // vehicleNo: "",
          vehicleType: formik.values.vtypes,
          itemList: invDat,
        },
        additionalData: {
          partyId: invoice.partyId || invoiceData?.partyid,
          pdflink: uri,
          invoiceType: invoice.invoiceType || invoiceData?.invoicetypecd,
          invoiceId: invoice.id || id,
          transporterId: formik.values.tObj.id,
          address: [
            {
              objecttype: 'Eway_Billfrom',
              pincode: formik.values.bfpincode,
              statecode: states.filter((option) => option?.value === formik.values.bfstates)[0].stateCode,
              district: formik.values.bfdistrict,
              line1: formik.values.bfAddress,
              city: formik.values.bfcity,
            },
            {
              objecttype: 'Eway_Billto',
              pincode: formik.values.btpincode,
              statecode: states.filter((option) => option?.value === formik.values.btstates)[0].stateCode,
              district: formik.values.btdistrict,
              line1: formik.values.btAddress,
              city: formik.values.btcity,
            },
            {
              objecttype: 'Eway_Dispatchfrom',
              pincode: formik.values.dfPincode,
              statecode: states.filter((option) => option?.value === formik.values.dfstates)[0].stateCode,
              district: formik.values.dfDistrict,
              line1: formik.values.dfAddress,
              city: formik.values.dfcity,
            },
            {
              objecttype: 'Eway_Dispatchto',
              pincode: formik.values.dtPincode,
              statecode: states.filter((option) => option?.value === formik.values.dtstates)[0].stateCode,
              district: formik.values.dtdistrict,
              line1: formik.values.dtAddress,
              city: formik.values.dtcity,
            },
          ],
        },
        ...(Object.keys(prevData).length > 0 ? { credentials: prevData } : null),
      };
      setBackdropOpen(true);
      try {
        const res = await axiosInstanceForLambda.post(API_ENDPOINTS.REACT_APP_EWAYBILL_URL, payload);
        if (res.status === 200) {
          showSuccessSnackbar('E-way Bill successfully generated');
          await createPdf({
            path: '',
            type: 'ewaybill',
            transactionid: res.data?.data?.ewaybillid,
          });
          if (invoice?.invoiceType === 'SalesInvoice' && saveNew === false) {
            navigate('/salesInvoiceReport');
          } else if (saveNew === true) {
            navigate(pathFrom);
          } else {
            navigate('/allpurchaseandexpense');
          }
        }
      } catch (error) {
        if (error.status === 500) {
          showWarningSnackbar('Internal Server Error');
        } else {
          const filteredArray = error.response.data?.details?.filter((item) => item !== null);
          const checkDistError = filteredArray.filter((er) => er.errorCode == '721')?.[0]?.errorCode;
          if (checkDistError) {
            setDistErr(true);
          }
          const formatted =
            filteredArray?.length === 1
              ? error.response.data?.details[0]?.errorDesc + '.'
              : filteredArray?.length > 1
              ? filteredArray
                  .map((item, index) => {
                    if (index === filteredArray.length - 1) return item.errorDesc + '.';
                    return item.errorDesc + ',';
                  })
                  .join(' ')
              : error.response.data.message
              ? error.response.data.message
              : '';

          const errorMessage = formatted ? formatted : error.response.statusText;
          showWarningSnackbar(errorMessage);
        }
      } finally {
        dispatch(einvAuthData({}));
        dispatch(einvAuth(false));
        dispatch(einvPreview({ preview: false, id: 0 }));
        dispatch(einvId(false));
        setBackdropOpen(false);
      }
    }
  };
  const docTypeOptions = documentTypeOptions[formik.values.subType] || [];
  return (
    <Paper>
      <Box
        sx={{
          marginLeft: '10px',
          marginTop: '20px',
          padding: '20px',
          height: { lg: '100%' },
          overflow: { lg: 'hidden' },
        }}
      >
        <Grid container spacing={4}>
          <Grid item lg={12}>
            <Grid lg={12}>
              {' '}
              <Typography variant="h2" sx={{ fontWeight: 'bold' }}>
                Transaction Details (Part A)
              </Typography>
            </Grid>
            <Grid item container spacing={2} lg={12} sx={{ marginTop: '2px', padding: '0px 10px', display: 'flex' }}>
              <Grid item lg={2}>
                <CustomAutoComplete
                  name="subType"
                  label="Sub Type"
                  options={formik.values.supply === 'O' ? outwardSubTypes : inwardSubTypes}
                  formik={formik}
                  ref={subTypeRef}
                  disabled={ewayData}
                />
              </Grid>
              {formik.values.subType === '8' ? (
                <Grid item lg={2}>
                  <CustomTextField label="Sub Type description" name="subTypeDesc" type="text" formik={formik} disabled={ewayData} />
                </Grid>
              ) : null}
              <Grid item lg={2}>
                <CustomAutoComplete
                  name="docType"
                  label="Document/Invoice Type"
                  options={
                    formik.values.supply === 'I' && formik.values.subType === '9'
                      ? [...docTypeOptions, { label: 'Bill of Entry', value: 'BOE' }]
                      : docTypeOptions
                  }
                  ref={docTypeRef}
                  disabled={ewayData}
                  formik={formik}
                />
              </Grid>
              <Grid item lg={2}>
                <CustomAutoComplete
                  name="transType"
                  label="Transaction Type"
                  options={transTypes}
                  formik={formik}
                  ref={transType}
                  disabled={ewayData}
                />
              </Grid>
              <Grid item lg={2}>
                {' '}
                <CustomTextField label="Document Number" name="docno" type="text" formik={formik} disabled={true} />
              </Grid>
              <Grid item lg={2}>
                {' '}
                <CustomTextField label="Document Date" name="docdate" type="text" formik={formik} disabled={true} />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid item lg={12}>
          <Grid lg={12}>
            {' '}
            <Typography variant="h2" sx={{ fontWeight: 'bold' }}>
              Bill From
            </Typography>
          </Grid>

          <Grid item container spacing={2} lg={12} sx={{ marginTop: '2px', padding: '0px 10px', display: 'flex' }}>
            <Grid item lg={2}>
              <CustomTextField
                label="Pincode"
                name="bfpincode"
                type="text"
                formik={formik}
                // required={
                //   formik.values.transType === "3" ||
                //   formik.values.transType === "4"
                // }
                disabled={true}
              />
            </Grid>
            {console.log(states, 'states')}
            <Grid item lg={2}>
              <CustomAutoComplete name="bfstates" label="States" options={states} formik={formik} disabled={true} />
            </Grid>
            <Grid item lg={2}>
              <CustomTextField name="bfdistrict" label="District" options={districtFrom} formik={formik} disabled={true} />
            </Grid>
            <Grid item lg={2}>
              <CustomTextField name="bfcity" label="City" formik={formik} disabled={true} />
            </Grid>
            <Grid item lg={4}>
              <CustomTextField label="Address" name="bfAddress" type="text" formik={formik} disabled={true} />
            </Grid>
          </Grid>
        </Grid>
        <Grid item lg={12}>
          <Grid lg={12}>
            {' '}
            <Typography variant="h2" sx={{ fontWeight: 'bold' }}>
              Bill To
            </Typography>
          </Grid>

          <Grid item container spacing={2} lg={12} sx={{ marginTop: '2px', padding: '0px 10px', display: 'flex' }}>
            <Grid item lg={2}>
              <CustomTextField label="Pincode" name="btpincode" type="text" formik={formik} disabled={true} />
            </Grid>
            <Grid item lg={2}>
              <CustomAutoComplete name="btstates" label="States" options={states} formik={formik} disabled={true} />
            </Grid>
            <Grid item lg={2}>
              <CustomTextField name="btdistrict" label="District" options={districtTo} formik={formik} disabled={true} />
            </Grid>
            <Grid item lg={2}>
              <CustomTextField name="btcity" label="City" formik={formik} disabled={true} />
            </Grid>
            <Grid item lg={4}>
              <CustomTextField label="Address" name="btAddress" type="text" formik={formik} disabled={true} />
            </Grid>
          </Grid>
        </Grid>
        <Grid item lg={12}>
          <Grid lg={12}>
            {' '}
            <Typography variant="h2" sx={{ fontWeight: 'bold' }}>
              Dispatch From
            </Typography>
          </Grid>
          <Grid item container spacing={2} lg={12} sx={{ marginTop: '2px', padding: '0px 10px', display: 'flex' }}>
            <Grid item lg={2}>
              <CustomTextField label="Pincode" name="dfPincode" type="text" formik={formik} states={stateList} disabled={true} />
            </Grid>
            <Grid item lg={2}>
              <CustomAutoComplete name="dfstates" label="States" options={states} formik={formik} disabled={true} />
            </Grid>
            <Grid item lg={2}>
              <CustomTextField name="dfDistrict" label="District" options={district1} formik={formik} disabled={true} />
            </Grid>
            <Grid item lg={2}>
              <CustomTextField name="dfcity" label="City" formik={formik} disabled={true} />
            </Grid>
            <Grid item lg={4}>
              <CustomTextField label="Address" name="dfAddress" type="text" formik={formik} disabled={true} />
            </Grid>
          </Grid>
        </Grid>
        <Grid item lg={12}>
          <Grid lg={12}>
            {' '}
            <Typography variant="h2" sx={{ fontWeight: 'bold' }}>
              Ship To
            </Typography>
          </Grid>

          <Grid item container spacing={2} lg={12} formik={formik} sx={{ marginTop: '2px', padding: '0px 10px', display: 'flex' }}>
            <Grid item lg={2}>
              <CustomTextField label="Pincode" name="dtPincode" type="text" formik={formik} disabled={true} />
            </Grid>
            <Grid item lg={2}>
              <CustomAutoComplete name="dtstates" label="States" options={states} formik={formik} disabled={true} />
            </Grid>
            <Grid item lg={2}>
              <CustomTextField label="District" name="dtdistrict" formik={formik} options={district2} disabled={true} />
            </Grid>
            <Grid item lg={2}>
              <CustomTextField label="City" name="dtcity" formik={formik} disabled={true} />
            </Grid>
            <Grid item lg={4}>
              <CustomTextField label="Address" name="dtAddress" type="text" formik={formik} disabled={true} />
            </Grid>
          </Grid>
        </Grid>
        <Grid item lg={12}>
          <Grid lg={12}>
            {' '}
            <Typography variant="h2" sx={{ fontWeight: 'bold' }}>
              Transportation Details (Part B){' '}
            </Typography>
          </Grid>
          <Grid item container lg={12} spacing={2} sx={{ marginTop: '2px', padding: '0px 10px', display: 'flex' }}>
            <Grid item lg={4}>
              <CustomRadioButton name="modes" arr={mode} label="Modes" formik={formik} disabled={ewayData && editPartB === false} />
            </Grid>
            <Grid item lg={2}>
              <CustomAutoComplete
                label="Transporter Name"
                name="tname"
                formik={formik}
                setTransporterOpen={setTransporterOpen}
                disabled={ewayData && editTransporter === false}
                options={[...transporter, { label: 'Add Transporter', value: 'gg' }]}
              />
            </Grid>

            <Grid item lg={2}>
              {' '}
              <FormikDatePicker
                label="Transporter Date"
                name="tDate"
                type="text"
                disabled={ewayData && editPartB === false}
                required={formik.values.modes != '1' ? true : false}
                formik={formik}
              />
            </Grid>
            {console.log(formik.values, 'ormik.values')}
            <Grid item lg={3}>
              {' '}
              <CustomTextField
                label="Transporter Document Number"
                name="tdoc"
                type="text"
                formik={formik}
                disabled={ewayData && editPartB === false}
                required={formik.values.modes != '1' ? true : false}
              />
            </Grid>
            <Grid item lg={4}>
              <CustomRadioButton
                name="vtypes"
                arr={vehicleType}
                disabled={ewayData && editPartB === false}
                label="Vehicle Type"
                formik={formik}
              />
            </Grid>
            <Grid item lg={2}>
              {' '}
              <CustomTextField label="Vehicle Number" name="vno" disabled={ewayData && editPartB === false} type="text" formik={formik} />
            </Grid>
            {editPartB === true && (
              <>
                <Grid item lg={2}>
                  <Autocomplete
                    id="state"
                    options={states}
                    getOptionLabel={(option) => option?.label || ''}
                    value={states.find((option) => option?.stateCode === editPartBDetails?.state?.stateCode) || null}
                    onChange={(_, newValue) => {
                      setEditPartBDetails((prev) => ({
                        ...prev,
                        state: newValue,
                      }));
                    }}
                    size="small"
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="State"
                        sx={{
                          '.MuiFormLabel-asterisk': {
                            color: 'danger.main',
                            fontSize: '20px',
                            fontWeight: 'bold',
                          },
                        }}
                        required={true}
                      />
                    )}
                  />
                </Grid>
                <Grid item lg={2}>
                  <TextField
                    size="small"
                    value={editPartBDetails.city}
                    label={'City'}
                    fullWidth
                    sx={{
                      '.MuiFormLabel-asterisk': {
                        color: 'danger.main',
                        fontSize: '20px',
                        fontWeight: 'bold',
                      },
                    }}
                    required={true}
                    onChange={(e) =>
                      setEditPartBDetails((prev) => ({
                        ...prev,
                        city: e.target.value,
                      }))
                    }
                  />
                </Grid>
                <Grid item lg={2}>
                  <Autocomplete
                    id="reasonCode"
                    options={editPartBReasons}
                    getOptionLabel={(option) => option?.label || ''}
                    value={editPartBReasons.find((option) => option?.value === editPartBDetails?.reasonCode?.value) || null}
                    onChange={(_, newValue) => {
                      setEditPartBDetails((prev) => ({
                        ...prev,
                        reasonCode: newValue,
                      }));
                    }}
                    size="small"
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Reason Code"
                        sx={{
                          '.MuiFormLabel-asterisk': {
                            color: 'danger.main',
                            fontSize: '20px',
                            fontWeight: 'bold',
                          },
                        }}
                        required={true}
                      />
                    )}
                  />
                </Grid>
                <Grid item lg={5.2}>
                  <TextField
                    size="small"
                    value={editPartBDetails.reasonDescription}
                    label={'Reason Description'}
                    sx={{
                      width: '510px',
                      '.MuiFormLabel-asterisk': {
                        color: 'danger.main',
                        fontSize: '20px',
                        fontWeight: 'bold',
                      },
                    }}
                    required={true}
                    multiline
                    rows={3}
                    onChange={(e) =>
                      setEditPartBDetails((prev) => ({
                        ...prev,
                        reasonDescription: e.target.value,
                      }))
                    }
                  />
                </Grid>
              </>
            )}

            {distErr ? (
              <Grid item lg={2}>
                {' '}
                <CustomTextField
                  label="Distance in kms"
                  name="distance"
                  type="text"
                  disabled={ewayData && editPartB === false}
                  formik={formik}
                />
              </Grid>
            ) : null}
          </Grid>
        </Grid>
        {ewayData ? (
          <Stack direction="row" spacing={2} justifyContent="center" sx={{ marginTop: '20px' }}>
            <Button
              variant="contained"
              onClick={() => {
                navigate(-1);
                localStorage.setItem('ewayCheck', true);
              }}
            >
              Back
            </Button>
            <Button variant="contained" onClick={() => setPreviewOpen(true)}>
              Preview
            </Button>
            {console.log(ewayData, 'ewayData')}
            {(ewayData.status === 'Active' || ewayData.status === 'ACT') && (
              <Button variant="contained" onClick={handlePartB}>
                {editPartB === true || editTransporter === true ? 'Update' : 'Edit'}
              </Button>
            )}
            {(editPartB === true || editTransporter === true) && (
              <Button
                variant="contained"
                onClick={() => {
                  setEditPartB(false);
                  setEditTransporter(false);
                }}
              >
                Cancel
              </Button>
            )}
          </Stack>
        ) : (
          <Stack direction="row" spacing={2} justifyContent="center" sx={{ marginTop: '20px' }}>
            {location.pathname.includes('edit') ? (
              <Button variant="contained" onClick={() => setPreviewOpen(true)}>
                Preview
              </Button>
            ) : null}
            <Button variant="contained" onClick={saveChanges}>
              Submit
            </Button>
          </Stack>
        )}
        <EWayBillPreview open={previewOpen} setOpen={setPreviewOpen} data={ewayData} invoiceData={invoiceData} />
      </Box>
      {transporterOpen ? (
        <Transporter
          setList={setTransporter}
          list={transporter}
          formik={formik}
          open={transporterOpen}
          setOpen={setTransporterOpen}
          listTransporters={listTransporters}
        />
      ) : null}
      {previewOpen ? <EWayBill Preview open={previewOpen} setOpen={setPreviewOpen} data={ewayData} invoiceData={invoiceData} /> : null}
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={backdropOpen}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </Paper>
  );
};

export default EWayBill;
